<template>
    <div style="width: 100%;">
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/theme/dark'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import util from '../utilitarios/util.js'

export default {
    name : "cmpgraficopie",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'subtitulo',
        'rotulo',
        'legendas',
        'dados',
			'visualizarlegenda',
			'posicaolabel'
    ],
    computed:{
        temaSistema(){
            return this.$store.state.temasistema;
        },
        options(){
            return {
                title: {
                    text: this.titulo || '',
                    subtext: this.subtitulo || '',
                    left: 'center',
                    textStyle: {
                        fontSize: 12
                    },
                    subtextStyle: {
                        fontSize: 8
                    }
                },
                color: util.gerarpaletagrafico(this.temaSistema, 11),
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    show: this.visualizarlegenda,
                    orient: 'vertical',
                    left: 'left',
                    top: '20',
                    data: this.legendas || [],
                    textStyle: {
                        fontSize: 8
                    }
                },
                series: [
                    {
                        name: this.rotulo || '',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '50%'],
                        avoidLabelOverlap: true,
                        data: this.dados || [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label : {
                            fontSize: 8,
                            position: this.posicaolabel || 'outside',
                            alignTo: 'edge',
                            margin: 20
                        }
                    }
                ]
            };
        }
    }    
}
</script>
